<template>
<div :ref="LoadingObj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">支付方式详情</span>
        <div class="TTL-BTN-LIST">
            <wcbutton :option="{title:'返回支付方式管理',type:'del'}" class="left15" @finish="(val)=> {$parent.JUMPVIEW({name:'EsPayment'})}" />
        </div>
    </div>

    <div class="ttl-goods-table top40">
        <table border="1" style="border-collapse: collapse;border-spacing: 0;">
            <tr>
                <th width="20%" align="center">支付名称</th>
                <th width="20%" align="center">上下架</th>
            </tr>
            <tr>
                <td align="center">{{paymentinfo.name}}</td>
                <td align="center">{{paymentinfo.isshow==0 ? '下架' : '上架'}}</td>
            </tr>
        </table>
    </div>

    <div class="TTL-renew-detail top50" v-if="paymentinfo.id==2">
        <span class="TTL-renew-title">设置详情</span>
        <div class="TTL-table top30">
            <el-table :data="paymentinfo.child" stripe="true" empty-text="" >
                <template v-slot:empty><el-empty description="暂无数据" /></template>
                <el-table-column label="logo" align="center">
                    <template #default="scope">
                        <wcimage :value="scope.row.thumb" :option="{size:'middle'}" />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="支付名称" align="center" />
                <el-table-column prop="appid" label="appid" align="center" />
                <el-table-column prop="appsecret" label="appsecret" align="center" />
                <el-table-column prop="merchid" label="商户号" align="center" />
                <el-table-column label="上下架" align="center">
                    <template #default="scope">
                        <el-switch v-model="scope.row.isshow" @change="ChangeShow(scope.row)" />
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
            
</div>


</template>

<script>
import INTERFACE_MODEL_PAYMENT from '@/Interface/Es/payment';
export default {
    components:{},
    data() {
        return {
            LoadingObj:'PaymentDetail',  //loading对象   
            paymentinfo:{},

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.GetPaymentDetail(data.param.id);
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetPaymentDetail(data.param.id);
            } 
        },


        //获取续费设置详情
        GetPaymentDetail(id) {
            INTERFACE_MODEL_PAYMENT.GET_PAYMENT_DETAIL({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.paymentinfo=res.data;
                 var child=this.paymentinfo.child;
                 for(var i in child) child[i].isshow=child[i].isshow==0 ? false : true;
                 console.log(this.paymentinfo);
            });
        },
        

        /** 修改支付上下架类型 **/
        ChangeShow(item) {
            INTERFACE_MODEL_PAYMENT.UPDATE_SHOW({id:item.id,isshow:item.isshow}).then((res) => {
                 if(res.status > 0) return false;
            });
        },

    },
}
</script>
<style scoped>
.ttl-goods {padding:20px 15px 50px 15px;width:calc(100% - 30px);}
.ttl-member-info {display: inline-flex;align-items: center;width:100%;font-size:0;}
.ttl-member-info i {font-style: normal;color:#666eeb;font-size:13px;cursor: pointer;}
.ttl-member-info .el-image {width:80px;height:80px;border-radius: 50%;box-shadow: 0 0 10px #dddddd;}
.ttl-member-info span {display: inline-flex;align-items: center;font-size:13px;color:#666666;}
.ttl-frozen {box-shadow: 0 !important;width:20px !important;height: 20px !important;}
.ttl-member-status {display: inline-flex;align-items: center;}

.ttl-goods-table {display:inline-block;width:100%;}
.ttl-goods-table table {width:100%;border-color: #EBEDF0;padding:0;}
.ttl-goods-table table th {background-color: #EBEDF0;}
.ttl-goods-table table th,.ttl-goods-table table td {padding:20px;font-size:13px;color:#333333;font-weight: normal;}
.ttl-goods-table .el-image {width:60px;height: 60px;border-radius: 50%;box-shadow: 0 0 10px #EBEDF0;}
.numbers {color:#666eeb;cursor: pointer;}
.TTL-renew-detail {display: inline-block;width:100%;}
.TTL-renew-title {display: inline-block;width:100%;font-size:13px;color:#666666;}
</style>